export const fieldsInfo: any = {

  dateFields: [
    'expiration_date',
    'effective_date'
  ],

  selectFields: [
    'currency_code'
  ],

  quarteredSizeFields: [
    'currency_code',
    'effective_date',
    'expiration_date',
  ],

  priceFields: [
    'price_sheet_name',
    'price_zone',
    'price_sheet_number'
  ],

};
